import { createFileRoute, Navigate } from "@tanstack/react-router";

export function DesignSystemFontsRedirect() {
  return <Navigate to="/admin/design-system/fonts" />;
}

export const Route = createFileRoute("/design-system/fonts")({
  component: DesignSystemFontsRedirect,
});
